import React from "react";
import { SortableContext, useSortable, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import "./SkillMastery.scss";
import { getGlobalSkillData } from "./SkillSimulator";
import { DndContext, DragEndEvent } from "@dnd-kit/core";

export type MasterySkill = {
    skill: number;
    id: number;
}

interface SkillMasteryProps {
    skills: MasterySkill[];
    repeat: boolean;
    onRepeatChange?: (val: boolean) => void;
    onSkillsChange?: (skills: MasterySkill[]) => void;
    onSkillAddRequest?: (id: number) => void;
    onCloseBtnClicked?: () => void;
}

interface MasteryEntryProps {
    skill: number;
    id: number;
    idx: number;
    onDeleteBtnClicked?: () => void;
}

export enum SpecialSkills {
    STRIKE = -1,
    STEP = -2
}

export function isSpecialSkill(id: number) {
    return SpecialSkills.STRIKE == id || SpecialSkills.STEP == id;
}

const specialSkillNames: Record<number, string> = {
    [SpecialSkills.STEP]: "Krok do przodu",
    [SpecialSkills.STRIKE]: "Zwykły atak"
}

function MasteryEntry(props: MasteryEntryProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
      } = useSortable({id: props.id});

      if (transform) transform.x = 0;
      
      const style = {
        transform: CSS.Transform.toString(transform),
        transition,
      };
      
      const skillName = specialSkillNames[props.skill] ?? getGlobalSkillData()?.skills.find(s => s.id == props.skill)?.name;
      return (
        <div className="mastery-skill">
            <div className="mastery-skill-id">{props.idx + 1}.</div>
            <div className="mastery-skill-inner" ref={setNodeRef} style={style} {...attributes}>
                <span {...listeners} className="mastery-skill-name">{skillName ?? "Error:skill-name"}</span>
                <span onClick={props.onDeleteBtnClicked} className="mastery-skill-delete">⨯</span>
            </div>
        </div>
      );
}

export class SkillMastery extends React.Component<SkillMasteryProps> {
    constructor(props: SkillMasteryProps) {
        super(props);
        this.onDragEnd = this.onDragEnd.bind(this);
        this.onRepeatChange = this.onRepeatChange.bind(this);
    }
    private onDragEnd(ev: DragEndEvent) {
        if (ev.active && ev.over && ev.active.id != ev.over.id) {
            const mastery = [...this.props.skills];
            const ind2 = mastery.findIndex(skill => skill.id == ev.active.id);
            const ind1 = mastery.findIndex(skill => skill.id == ev.over!.id);
            const [skill] = mastery.splice(ind2, 1);
            mastery.splice(ind1, 0, skill);
            this.props.onSkillsChange?.(mastery);
        }
    }
    private onRepeatChange() {
        this.props.onRepeatChange?.(!this.props.repeat);
    }
    private addSkill(id: number) {
        this.props.onSkillAddRequest?.(id);
    }
    render(): React.ReactNode {
        return <div className="skill-simulator-mastery">
            <div className="mastery-header">Mistrzostwo walk ({this.props.skills.length} / 20)</div>
            <div className="mastery-info">
                <div>Kliknij umiejętności, aby dodać je do mistrzostwa.</div>
                <div>Elementy listy można przeciągać aby zmienić kolejność.</div>
            </div>
            <div className="mastery-skills">
                <DndContext onDragEnd={this.onDragEnd}>
                    <SortableContext items={this.props.skills.map(s => s.id)} strategy={verticalListSortingStrategy}>
                        {this.props.skills.map((skill, idx) => 
                            <MasteryEntry idx={idx} key={skill.id} skill={skill.skill} id={skill.id} 
                              onDeleteBtnClicked={() => {
                                const mastery = [...this.props.skills];
                                mastery.splice(idx, 1);
                                this.props.onSkillsChange?.(mastery);
                              }} />
                        )}
                    </SortableContext>
                </DndContext>
            </div>
            <div className="mastery-repeat">
                <label htmlFor="mastery-repeat">Powtarzaj</label>
                <input onChange={this.onRepeatChange} id="mastery-repeat" type="checkbox" checked={this.props.repeat} />
            </div>
            <div className="mastery-pseudoskills">
                <div onClick={() => this.addSkill(SpecialSkills.STRIKE)} className="btnlike">Dodaj zwykły atak</div>
                <div onClick={() => this.addSkill(SpecialSkills.STEP)} className="btnlike">Dodaj krok do przodu</div>
            </div>
            <div onClick={this.props.onCloseBtnClicked} className="mastery-btn">Zamknij</div>
        </div>
    }
}

export function test(){};